<div class="account-limits-container">
  <div class="account-limits-title">Business Account Transaction Limits</div>

  <div class="limits">
    @if (businessAccountTransactionLimits.length || !loading) {
      @for (item of businessAccountTransactionLimits; track item.id) {
        <app-transaction-limit-item [limitItem]="item"></app-transaction-limit-item>
      }
    } @else {
      <div class="loading-container">
        @for (row of [1, 2, 3, 4]; track row) {
          <div class="row">
            <div class="label"><div class="loading-placeholder"></div></div>
            <div class="value" [class.single]="row === 1">
              <div class="loading-placeholder"></div>
              @if (row !== 1) {
                <div class="loading-placeholder"></div>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
